<script setup>
import CustomFieldDefaultPreview from './customFields/preview/CustomFieldDefaultPreview.vue';
import CustomFieldOptionPreview from './customFields/preview/CustomFieldOptionPreview.vue';
import CustomFieldDatePreview from './customFields/preview/CustomFieldDatePreview.vue';

defineProps({
    customFields: {
        required: true,
        type: Array,
    },
});

const customFieldPreviewComponents = {
    dropdown: CustomFieldOptionPreview,
    radio: CustomFieldOptionPreview,
    tag: CustomFieldOptionPreview,
    checkbox: CustomFieldOptionPreview,
    text: CustomFieldDefaultPreview,
    number: CustomFieldDefaultPreview,
    date: CustomFieldDatePreview,
};
</script>

<template>
    <div>
        <div
            v-for="field in customFields"
            :key="field.id"
            :data-qa="`preview custom field ${field.id}`"
            class="flex flex-col"
        >
            <strong>{{ field.label }}</strong>
            <component
                :is="customFieldPreviewComponents[field.type]"
                v-if="field.value || field.value === 0"
                :field="field"
                class="text-gray-700 [word-break:break-word]"
            />
            <em
                v-else
                class="italic text-gray-700"
            >
                Keine Angabe.
            </em>
        </div>
    </div>
</template>

<style lang="scss">

</style>
